import { useBunja } from 'bunja/react';
import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useTranslations } from 'next-intl';

import { stack } from '@flipster/styled-system/patterns';
import { NumberInput } from '@flipster/ui';
import { UsdtCurrency } from '@flipster/utils/constants/currency';

import { tradeSymbolBunja } from '@web/app/[locale]/(web)/trade/_misc/symbol';
import PriceRateButtons from '@web/components/PriceRateButtons';

import { spotFormBunja } from '../bunja/form';
import { formItem, label, labelWrapper } from '../styles';

const TriggerPricePercentList = ['-2', '-1', '+1', '+2'];

const PriceForm = () => {
  const transTrade = useTranslations('Trade.r250401');

  const { symbolInfoWithDefaultAtom } = useBunja(tradeSymbolBunja);
  const { triggerPriceAtom, changeTriggerPricePercentAtom } = useBunja(spotFormBunja);

  const symbolInfo = useAtomValue(symbolInfoWithDefaultAtom);
  const changeTriggerPricePercent = useSetAtom(changeTriggerPricePercentAtom);
  const [triggerPrice, setTriggerPrice] = useAtom(triggerPriceAtom);

  const { pricePrecision } = symbolInfo;

  return (
    <>
      <div className={labelWrapper}>
        <span className={label}>{transTrade('Trigger_price')}</span>
      </div>
      <div className={formItem}>
        <div className={stack({ gap: 8, w: '100%' })}>
          <NumberInput
            value={triggerPrice}
            name='triggerPrice'
            precision={pricePrecision}
            currency={UsdtCurrency}
            onChange={(p) => setTriggerPrice(p || '0')}
          />
          <PriceRateButtons
            items={TriggerPricePercentList}
            onClick={(e) => changeTriggerPricePercent(e.currentTarget.value)}
          />
        </div>
      </div>
    </>
  );
};

export default PriceForm;
